import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.InviteUsersPopup', {
    title: 'Invite your team members to the Organisation "{companyName}"',
    addComment: 'Add comment',
    inviteUsers: 'Invite Users',
    descriptionTextNoInviteMessage: 'The following users will be invited by email to join the Organisation.',
    descriptionText: 'Add a welcome message for the invitees; they will see it in the email. This is optional.',
});
